export enum DomExperienceType {
  domExperienceV1 = 'domExperienceV1',
}
